import Config from "./env";

const localPreviewPort = "4173";

interface AuthConfig {
  isDev: boolean;
  redirectUri: string;
  clientId: string;
}

const devUrls = ["localhost", "127.0.0.1", "gxm-dev.hsp.com"];

const nonDevUrls = [
  "gatewaygxm.hsp.com",
  "gxm-qa.hsp.com",
  "gxm-staging.hsp.com",
];

export const getAuthConfig = (): AuthConfig => {
  const { hostname, origin, port } = window.location;

  const isDev = devUrls.includes(hostname) && port !== localPreviewPort;

  // Validate URL
  if (!devUrls.includes(hostname) && !nonDevUrls.includes(hostname)) {
    throw new Error(`Unknown URL detected: ${hostname}`);
  }

  console.log({
    hostname,
    origin,
    port,
    isDev,
    redirectUri: `${origin}/callback`,
    clientId: Config.WORKOS_CLIENT_ID,
  });

  return {
    isDev,
    redirectUri: `${origin}/callback`,
    clientId: Config.WORKOS_CLIENT_ID,
  };
};
